import { createSlice } from "@reduxjs/toolkit";
const themeColorSlice = createSlice({
  name: "theme",
  initialState: {
    loading: false,
    selectedStoreTheme: {
      theme: {
        color: "#6D40FA",
        backgroundColor: "#6D40FA",
      },
    },
  },
  reducers: {
    setThemeColorLoading(state) {
      state.loading = true;
    },
    setThemeColorSuccess(state, action) {
      state.storeTheme = action.payload;
      state.loading = false;
    },
    setThemeColorFail(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
  },
});

export const { setThemeColorLoading, setThemeColorSuccess, setThemeColorFail } =
  themeColorSlice.actions;
export default themeColorSlice.reducer;
